import {
  type Column,
  type HeaderGroup,
  type Row,
  type RowData,
  type TableOptions,
  type TableState,
  // oxlint-disable-next-line no-restricted-imports
  useReactTable,
} from "@tanstack/react-table";

export type ReactTableNoMemo<TData extends RowData> = {
  table: ReturnType<typeof useReactTable<TData>>;
  rows: Row<TData>[];
  headerGroups: HeaderGroup<TData>[];
  leafColumns: Column<TData>[];
  pageCount: number;
  state: TableState;
};

export const useReactTableNoMemo = <TData extends RowData>(
  options: TableOptions<TData>,
): ReactTableNoMemo<TData> => {
  "use no memo";
  const table = useReactTable(options);

  return {
    table,
    rows: table.getRowModel().rows,
    headerGroups: table.getHeaderGroups(),
    leafColumns: table.getAllLeafColumns(),
    pageCount: table.getPageCount(),
    state: table.getState(),
  };
};
